import React, { useEffect, useRef, useState } from "react";
import Loading from "../../../../Extra/Loading";
import DownloadExcel from "../../../../Extra/DownloadExcel";
import {
  flattenData,
  getCurrentFY,
  getDaysInFYMonths,
  getFinancialYearMonthsPassed,
} from "../../../../Utilitie";
import * as echarts from "echarts";
import MonthWisePWITOHOGraph from "../GraphView.jsx/MonthWisePWITOHOGraph";
import MonthWisePWITOHOGraph2 from "../GraphView.jsx/MonthWisePWITOHOGraph2";
import AvgMWPWITOHOGraph from "../GraphView.jsx/AvgMWPWITOHOGraph";
import AvgMWPWIHOGraph from "../GraphView.jsx/AvgMWPWIHOGraph";
import MonthWisePWIHOGraph from "../GraphView.jsx/MonthWisePWIHOGraph";
import MonthWisePWIHOGraph2 from "../GraphView.jsx/MonthWisePWIHOGraph2";
import BestEverPWITOHO from "./BestEverPWITOHO";

const MonthWisePWITOHOReport = ({
  PWIdata,
  selectedFy,
  getSectionWorkingDays,
  prevPWIdata,
  currPWIdata,
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedRT, setSelectedRT] = useState("Jumbo");
  const tableRef = useRef();

  const monthOrder = [
    // "April",
    // "May",
    // "June",
    // "July",
    // "August",
    // "September",
    // "October",
    // "November",
    // "December",
    // "January",
    // "February",
    // "March",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
    "Jan",
    "Feb",
    "Mar",
  ];

  const sortedPrev = [...prevPWIdata].sort(
    (a, b) => monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month),
  );

  const t = flattenData(sortedPrev);
  const sortedCurr = currPWIdata
    ? [...currPWIdata].sort(
        (a, b) => monthOrder.indexOf(a.month) - monthOrder.indexOf(b.month),
      )
    : [];

  const [allMonths, setAllMonths] = useState([...monthOrder]);
  const mpassed = getFinancialYearMonthsPassed(getCurrentFY(), false);
  const [selectedMonths, setSelectedMonths] = useState([...mpassed]);

  const sectionSet = new Set();
  [...sortedPrev, ...sortedCurr].forEach((month) =>
    month?.data?.forEach((d) => d.section && sectionSet.add(d.section)),
  );
  const allSections = Array.from(sectionSet).sort();

  const [selectedSections, setSelectedSections] = useState([]);

  const cmdata = sortedCurr.filter((o) =>
    selectedMonths.includes(o.month.slice(0, 3)),
  );

  const pmdata = sortedPrev.filter((o) =>
    selectedMonths.includes(o.month.slice(0, 3)),
  );
  useEffect(() => {
    if (allSections.length) setSelectedSections(allSections);
  }, [JSON.stringify(allSections)]);

  const getSectionData = (monthData, section) =>
    monthData?.data?.find((d) => d.section === section) || {};

  const computeVariation = (prevVal = 0, currVal = 0) => {
    if (!prevVal && !currVal) return "0%";
    if (!prevVal) return "∞%";
    return `${(((currVal - prevVal) / prevVal) * 100).toFixed(1)}%`;
  };
  const dataToPassForDayCont = currPWIdata.filter((f) =>
    selectedMonths.includes(f.month.slice(0, 3)),
  );
  const dataToPassForDayContPrev = prevPWIdata.filter((f) =>
    selectedMonths.includes(f.month.slice(0, 3)),
  );
  const daysCount = {
    current: getSectionWorkingDays(dataToPassForDayCont),
    prev: getSectionWorkingDays(dataToPassForDayContPrev),
  };

  return (
    <div>
      <div className="papaDiv">
        <div className="d-flex justify-content-between flex-wrap gap-2 mb-2">
          <div>
            <label className="fw-bold me-2">Select Sections:</label>
            {allSections.map((section) => {
              const active = selectedSections.includes(section);
              return (
                <span
                  key={section}
                  className={`badge px-3 py-2 me-2 ${
                    active ? "bg-primary text-white" : "bg-secondary text-white"
                  }`}
                  onClick={() =>
                    setSelectedSections((prev) =>
                      prev.includes(section)
                        ? prev.filter((s) => s !== section)
                        : [...prev, section],
                    )
                  }
                  style={{ cursor: "pointer", userSelect: "none" }}
                >
                  {section}
                </span>
              );
            })}
          </div>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => setSelectedSections([])}
          >
            Deselect All
          </button>
        </div>

        <div className="d-flex justify-content-between flex-wrap gap-2 mt-3 ">
          <div>
            <label className="fw-bold me-2">Select Months:</label>
            {allMonths.map((month) => {
              const active = selectedMonths.includes(month);
              return (
                <span
                  key={month}
                  className={`badge px-3 py-2 me-2 mb-1 ${
                    active ? "bg-success text-white" : "bg-secondary text-white"
                  }`}
                  onClick={() =>
                    setSelectedMonths((prev) =>
                      prev.includes(month)
                        ? prev.filter((m) => m !== month)
                        : [...prev, month],
                    )
                  }
                  style={{ cursor: "pointer", userSelect: "none" }}
                >
                  {month}
                </span>
              );
            })}
          </div>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => setSelectedMonths([])}
          >
            Deselect All
          </button>
        </div>
      </div>
      <div className="row">
        {" "}
        <div className="col-md-12">
          <div className="row">
            <h5 className="bg-dark text-white p-2"> AVG PER DAY COMPARISON</h5>
            <div className="col-md-6">
              {" "}
              <AvgMWPWITOHOGraph
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrev}
                sortedCurr={sortedCurr}
                selectedFy={selectedFy}
              />
            </div>{" "}
            <div className="col-md-6">
              {" "}
              <AvgMWPWIHOGraph
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrev}
                sortedCurr={sortedCurr}
                selectedFy={selectedFy}
              />
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row">
            <h5 className="bg-dark text-white p-2"> MONTH WISE COMPARISON </h5>
            <div className="col-md-6">
              {" "}
              <MonthWisePWITOHOGraph
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrev}
                sortedCurr={sortedCurr}
                selectedFy={selectedFy}
              />
            </div>{" "}
            <div className="col-md-6">
              {" "}
              <MonthWisePWIHOGraph
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrev}
                sortedCurr={sortedCurr}
                selectedFy={selectedFy}
              />
            </div>
          </div>
        </div>
        <div className="col-md-12">
          <div className="row">
            <h5 className="bg-dark text-white p-2"> SECTION WISE COMPARISON</h5>
            <div className="col-md-6">
              {" "}
              <MonthWisePWITOHOGraph2
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrev}
                sortedCurr={sortedCurr}
                selectedFy={selectedFy}
              />
            </div>{" "}
            <div className="col-md-6">
              {" "}
              <MonthWisePWIHOGraph2
                selectedMonths={selectedMonths}
                selectedSections={selectedSections}
                sortedPrev={sortedPrev}
                sortedCurr={sortedCurr}
                selectedFy={selectedFy}
              />
            </div>
          </div>
        </div>
      </div>

      <div>
        <div>
          {" "}
          <h5 className="d-flex justify-content-between bg-dark text-white p-2">
            {" "}
            PWI Month Wise T/O & H/O Report
          </h5>
        </div>
        <div
          className="table-responsive table-wrapper"
          style={{ maxHeight: "700px" }}
        >
          {loading && <Loading />}
          <table
            ref={tableRef}
            border="1"
            cellPadding="8"
            className="table table-striped table-bordered "
            style={{ fontSize: "13px" }}
          >
            <thead className="table-dark text-center align-middle">
              <tr>
                <th rowSpan={3}>Month</th>
                <th colSpan={selectedSections.length * 2}>
                  Prev Year ({selectedFy.replace(/\d+/g, (y) => +y - 1)})
                </th>{" "}
                <th rowSpan={3}>Total T/O</th>
                <th rowSpan={3}>Total H/O</th>
                <th colSpan={selectedSections.length * 2}>
                  Curr Year ({selectedFy})
                </th>{" "}
                <th rowSpan={3}>Total T/O</th>
                <th rowSpan={3}>Total H/O</th>
                <th colSpan={selectedSections.length * 2}>Variation %</th>
              </tr>
              <tr>
                {selectedSections.map((section) => (
                  <th key={`prev-${section}`} colSpan={2}>
                    {section}
                  </th>
                ))}

                {selectedSections.map((section) => (
                  <th key={`curr-${section}`} colSpan={2}>
                    {section}
                  </th>
                ))}
                {selectedSections.map((section) => (
                  <th key={`var-${section}`} colSpan={2}>
                    {section}
                  </th>
                ))}
              </tr>
              <tr>
                {[
                  ...selectedSections,
                  ...selectedSections,
                  ...selectedSections,
                ].map((_, idx) => (
                  <React.Fragment key={idx}>
                    <th>T/O</th>
                    <th>H/O</th>
                  </React.Fragment>
                ))}
              </tr>
            </thead>
            {selectedMonths.length > 0 && selectedSections.length > 0 && (
              <tbody>
                {selectedMonths.map((month) => {
                  const prevMonth = sortedPrev.find(
                    (m) => m.month.slice(0, 3) === month,
                  );
                  const currMonth = sortedCurr.find(
                    (m) => m.month.slice(0, 3) === month,
                  );

                  return (
                    <tr key={month}>
                      <td className="fw-bold text-capitalize">{month}</td>
                      {selectedSections.map((section) => {
                        const d = getSectionData(prevMonth, section);
                        return (
                          <>
                            <td>{d.to_value ?? "-"}</td>
                            <td>{d.ho_value ?? "-"}</td>
                          </>
                        );
                      })}
                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getSectionData(prevMonth, section);
                          return acc + Number(d.to_value || 0);
                        }, 0)}
                      </td>{" "}
                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getSectionData(prevMonth, section);
                          return acc + Number(d.ho_value || 0);
                        }, 0)}
                      </td>
                      {selectedSections.map((section) => {
                        const d = getSectionData(currMonth, section);
                        return (
                          <>
                            <td>{d.to_value ?? "-"}</td>
                            <td>{d.ho_value ?? "-"}</td>
                          </>
                        );
                      })}
                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getSectionData(currMonth, section);
                          return acc + Number(d.to_value || 0);
                        }, 0)}
                      </td>{" "}
                      <td className="fw-bold bg-light">
                        {selectedSections.reduce((acc, section) => {
                          const d = getSectionData(currMonth, section);
                          return acc + Number(d.ho_value || 0);
                        }, 0)}
                      </td>
                      {selectedSections.map((section) => {
                        const p = getSectionData(prevMonth, section);
                        const c = getSectionData(currMonth, section);
                        const toVar = computeVariation(p.to_value, c.to_value);
                        const hoVar = computeVariation(p.ho_value, c.ho_value);

                        return (
                          <>
                            <td>
                              {toVar.replace("-100.0%", "-").replace("∞%", "-")}
                            </td>
                            <td>
                              {hoVar.replace("-100.0%", "-").replace("∞%", "-")}
                            </td>
                          </>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            )}
            {selectedMonths.length > 0 && selectedSections.length > 0 && (
              <tfoot className="table-dark text-center fw-bold">
                <tr>
                  <td>Total</td>
                  {selectedSections.map((section) => {
                    let sumTo = 0,
                      sumHo = 0;
                    sortedPrev
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        sumTo += Number(d.to_value || 0);
                        sumHo += Number(d.ho_value || 0);
                      });
                    return (
                      <React.Fragment key={`prev-total-${section}`}>
                        <td>{sumTo}</td>
                        <td>{sumHo}</td>
                      </React.Fragment>
                    );
                  })}
                  <td>-</td>
                  <td>-</td>
                  {selectedSections.map((section) => {
                    let sumTo = 0,
                      sumHo = 0;
                    sortedCurr
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        sumTo += Number(d.to_value || 0);
                        sumHo += Number(d.ho_value || 0);
                      });
                    return (
                      <React.Fragment key={`curr-total-${section}`}>
                        <td>{sumTo}</td>
                        <td>{sumHo}</td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td>-</td>
                  <td>-</td>
                  {selectedSections.map((section) => {
                    let prevSumTo = 0,
                      prevSumHo = 0,
                      currSumTo = 0,
                      currSumHo = 0;
                    sortedPrev
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        prevSumTo += Number(d.to_value || 0);
                        prevSumHo += Number(d.ho_value || 0);
                      });
                    sortedCurr
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        currSumTo += Number(d.to_value || 0);
                        currSumHo += Number(d.ho_value || 0);
                      });
                    const toVar = computeVariation(prevSumTo, currSumTo);
                    const hoVar = computeVariation(prevSumHo, currSumHo);
                    return (
                      <React.Fragment key={`var-total-${section}`}>
                        <td>
                          {toVar.replace("-100.0%", "-").replace("∞%", "-")}
                        </td>
                        <td>
                          {hoVar.replace("-100.0%", "-").replace("∞%", "-")}
                        </td>
                      </React.Fragment>
                    );
                  })}
                </tr>
                <tr>
                  <td>Avg/M</td>
                  {selectedSections.map((section) => {
                    let sumTo = 0,
                      sumHo = 0;
                    sortedPrev
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        sumTo += Number(d.to_value || 0);
                        sumHo += Number(d.ho_value || 0);
                      });
                    return (
                      <React.Fragment key={`prev-total-${section}`}>
                        <td>{(sumTo / pmdata.length).toFixed(2)}</td>
                        <td>{(sumHo / pmdata.length).toFixed(2)}</td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td>-</td>
                  <td>-</td>
                  {selectedSections.map((section) => {
                    let sumTo = 0,
                      sumHo = 0;
                    sortedCurr
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        sumTo += Number(d.to_value || 0);
                        sumHo += Number(d.ho_value || 0);
                      });
                    return (
                      <React.Fragment key={`curr-total-${section}`}>
                        <td>{(sumTo / cmdata.length).toFixed(2)}</td>
                        <td>{(sumHo / cmdata.length).toFixed(2)}</td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td>-</td>
                  <td>-</td>
                  {selectedSections.map((section) => {
                    let prevSumTo = 0,
                      prevSumHo = 0,
                      currSumTo = 0,
                      currSumHo = 0;
                    sortedPrev
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        prevSumTo += Number(d.to_value || 0);
                        prevSumHo += Number(d.ho_value || 0);
                      });
                    sortedCurr
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        currSumTo += Number(d.to_value || 0);
                        currSumHo += Number(d.ho_value || 0);
                      });
                    const toVar = computeVariation(prevSumTo, currSumTo);
                    const hoVar = computeVariation(prevSumHo, currSumHo);
                    return (
                      <React.Fragment key={`var-total-${section}`}>
                        <td>-</td>
                        <td>-</td>
                      </React.Fragment>
                    );
                  })}
                </tr>{" "}
                <tr>
                  <td>Avg/D</td>
                  {selectedSections.map((section) => {
                    let sumTo = 0,
                      sumHo = 0;
                    sortedPrev
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        sumTo += Number(d.to_value || 0);
                        sumHo += Number(d.ho_value || 0);
                      });
                    const matchedSectionTotalWorkingDay =
                      daysCount.prev.find((f) => f.section === section)
                        ?.working_days || 1;

                    return (
                      <React.Fragment key={`prev-total-${section}`}>
                        <td>
                          {(sumTo / matchedSectionTotalWorkingDay).toFixed(2)}
                        </td>
                        <td>
                          {(sumHo / matchedSectionTotalWorkingDay).toFixed(2)}
                        </td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td>-</td>
                  <td>-</td>
                  {selectedSections.map((section) => {
                    let sumTo = 0,
                      sumHo = 0;
                    sortedCurr
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        sumTo += Number(d.to_value || 0);
                        sumHo += Number(d.ho_value || 0);
                      });
                    const matchedSectionTotalWorkingDay =
                      daysCount.current.find((f) => f.section === section)
                        ?.working_days || 1;
                    return (
                      <React.Fragment key={`curr-total-${section}`}>
                        <td>
                          {(sumTo / matchedSectionTotalWorkingDay).toFixed(2)}
                        </td>
                        <td>
                          {(sumHo / matchedSectionTotalWorkingDay).toFixed(2)}
                        </td>
                      </React.Fragment>
                    );
                  })}{" "}
                  <td>-</td>
                  <td>-</td>
                  {selectedSections.map((section) => {
                    let prevSumTo = 0,
                      prevSumHo = 0,
                      currSumTo = 0,
                      currSumHo = 0;
                    sortedPrev
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        prevSumTo += Number(d.to_value || 0);
                        prevSumHo += Number(d.ho_value || 0);
                      });
                    sortedCurr
                      .filter((m) =>
                        selectedMonths.includes(m.month.slice(0, 3)),
                      )
                      .forEach((m) => {
                        const d = getSectionData(m, section);
                        currSumTo += Number(d.to_value || 0);
                        currSumHo += Number(d.ho_value || 0);
                      });
                    const toVar = computeVariation(prevSumTo, currSumTo);
                    const hoVar = computeVariation(prevSumHo, currSumHo);
                    return (
                      <React.Fragment key={`var-total-${section}`}>
                        <td>-</td>
                        <td>-</td>
                      </React.Fragment>
                    );
                  })}
                </tr>
              </tfoot>
            )}
          </table>
          {(selectedMonths.length === 0 || selectedSections.length === 0) && (
            <div className="text-danger fw-bold">
              {" "}
              Please Select Months And Section
            </div>
          )}
        </div>
      </div>
      <DownloadExcel
        tableRef={tableRef}
        fileName={`  PWI Month Wise T/O & H/O Report - ${selectedFy}`}
      />
      <BestEverPWITOHO />
    </div>
  );
};

export default MonthWisePWITOHOReport;
